<template>
  <div class="comment__audit-compare-content comment__audit-compare-content_vertical-start">
    <span class="is-opacity">{{ beforeTitle }}</span>
    <icon
      data="@icon/arrow-to.svg"
      :fill="true"
      width="var(--icon-24)"
      height="var(--icon-24)"
      color="var(--monochrome05to04)"
      class="comment__audit-compare-content__arrow"
    />
    <span>{{ afterTitle }}</span>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue"

import { Comment } from "@/models"

const props = defineProps<{
  comment: Comment
}>()

const beforeTitle = computed(() => props.comment.before?.title ?? null)
const afterTitle = computed(() => props.comment.after?.title ?? null)
</script>
